export const PROPERTY_TYPE_KEY = 'property_type';
export const STATIC_SET_FILTER_KEY = 'static_set_ids';
